<div class="form-ubication-info">
  <div class="sub-title" id="general-title"
    [innerHTML]="copyService.copies.ubication_info_title">
  </div>
  <form class="form row" [formGroup]="formGroup">
    <div *ngIf="district_option" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <voxel-form-field id="providenceSelectionList" [label]="copyService.copies.ubication_info_providence" class="form-field-font vertical-margin">
          <vcl-autocomplete class="autocomplete-font" [id]="'input-value-providence'" [placeholder]="copyService.copies.ubication_info_providence_name" (change)="selectOptionProvidence($event)" required
              [notFoundTitle]="copyService.copies.ubication_info_providence_not_found" 
              [notFoundMessage]="copyService.copies.ubication_info_providence_not_found">
              <vcl-option [id]="option.district_id" *ngFor="let option of district_option" [value]="option.district_id" [selected]="option.district_id === selected_district">
                  {{ option.district }}
              </vcl-option>
          </vcl-autocomplete>
      </voxel-form-field>
    </div> 
    <div *ngIf="city_option" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <voxel-form-field id="citySelectionList" [label]="copyService.copies.ubication_info_city" class="form-field-font vertical-margin">
          <vcl-autocomplete class="autocomplete-font" [id]="'input-value-city'" [placeholder]="copyService.copies.ubication_info_city_name" (change)="selectOption($event)" required
              [notFoundTitle]="copyService.copies.ubication_info_city_not_found" 
              [notFoundMessage]="copyService.copies.ubication_info_city_not_found">
              <vcl-option [id]="'citySelection' + option.city_code" *ngFor="let option of options" [value]="option" [selected]="option.city_code === selectedCity.city_code && option.province_code === selectedCity.province_code">
                  {{ option.description }}
              </vcl-option>
          </vcl-autocomplete>
      </voxel-form-field>
    </div>
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.ubication_info_address }}"
        msgErr="{{ copyService.copies.ubication_info_error_direccion }}">
        <input vclInput placeholder="{{ copyService.copies.ubication_info_address_placeholder }}"
          id="inputValueAddress" maxlength="40" type="text" [value]="this.contactInfo.address.addressInput"
          (change)="reactiveInputChangeAddress()" formControlName="input-value-address">
      </vcl-form-field>
    </div>
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.ubication_info_other_details }}">
        <input id="inputValueAddressDetail" vclInput placeholder="{{ copyService.copies.ubication_info_other_details_placeholder }}"
          id="inputValueAddress" maxlength="30" type="text" [value]="this.contactInfo.address.detail"
          (change)="reactiveInputChangeAddress()" formControlName="input-value-addressDetail">
      </vcl-form-field>
    </div>
    <div *ngIf="showFields" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <voxel-form-field msgErr="{{ copyService.copies.ubication_info_error_msg }}" id="citySelectionList" [label]="copyService.copies.ubication_info_housing_type" class="form-field-font vertical-margin">
          <vcl-select formControlName="housing-selection" class="autocomplete-font" [id]="'input-value-housing-type'" [placeholder]="copyService.copies.ubication_info_housing_type_name" (change)="selectOptionHousing($event)" required
              [notFoundTitle]="copyService.copies.ubication_info_city_not_found" 
              [notFoundMessage]="copyService.copies.ubication_info_city_not_found">
              <vcl-select-option [id]="'housingSelection' + optionHousing.id" *ngFor="let optionHousing of optionsHousingType" [value]="optionHousing" [selected]="optionHousing.name === selectedHousingType.description && optionHousing.id === selectedHousingType.housingId">
                  {{ optionHousing.name }}
              </vcl-select-option>
          </vcl-select>
      </voxel-form-field>
    </div>
    <div *ngIf="showFields" class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <voxel-form-field msgErr="{{ copyService.copies.ubication_info_error_msg }}" id="citySelectionList" [label]="copyService.copies.ubication_info_stratum" class="form-field-font vertical-margin">
          <vcl-select formControlName="stratum-selection" class="autocomplete-font" [id]="'input-value-stratum'" [placeholder]="copyService.copies.ubication_info_select_stratum" (change)="selectOptionStratum($event)" required
              [notFoundTitle]="copyService.copies.ubication_info_city_not_found" 
              [notFoundMessage]="copyService.copies.ubication_info_city_not_found">
              <vcl-select-option [id]="'stratumSelection' + optionStratum.id" *ngFor="let optionStratum of optionsStratum" [value]="optionStratum" [selected]="optionStratum.name === selectedStratum">
                  {{ optionStratum.name }}
              </vcl-select-option>
          </vcl-select>
      </voxel-form-field>
    </div>
  </form>
</div>
<app-controls id="formUbicationInfoBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.ubication_info_button"
  [nextDisabled]="!formGroup.valid || selectedCity.province_code == 0" (next)="next()"></app-controls>
